define('viewmodels/Weightings_Thresholds/AMLControlsWeightings',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system'],
function (ko, router, appsecurity, navigation, app, logger, system) {
    var title = 'ControlsWeightings';
    var checkWeighting = 0;

    var ACWViewModel = {
        activate: activate,
        title: title,
        attached: attached,
        detached: detached,
        appsecurity: appsecurity,
        ControlAreaListW: ko.observableArray(),
        BusinessUnitsListW: ko.observableArray(), //inside grid first tab
        BusinessLevelList: ko.observableArray(), //for tabs
        WeightingsList: ko.observableArray(), // cell data for both the grids
        ClickedLevelDetailId: ko.observable(), //unused
        ClickedLevelDetailName: ko.observable(),
        saveWeightingsAMLControls: saveWeightingsAMLControls,
        saveAMLLevelControlsWeightings: saveAMLLevelControlsWeightings,
        WeightingsDataList: ko.observableArray(),
        WeightingsGridList: ko.observableArray(),
        OrgWeightingsDataList: ko.observableArray(),
        buildsaveConBULWeightingsList: buildsaveConBULWeightingsList,
        copyDataAMLControls: copyDataAMLControls,
        RiskLevelTabClick: RiskLevelTabClick,
        GetTotalWeightingsOverall: GetTotalWeightingsOverall,
        BusinessLevelDetailsList: ko.observableArray(),//inside grid sub org tabs
        Overalllowestlevel: ko.observable(),
        ClickedType: ko.observable(),
        GetRiskLevelSubtabs: GetRiskLevelSubtabs,
        BULWeightingsListSave: ko.observableArray(),
        copyOverallData: copyOverallData,
        ErrorStatus: ko.observable(0),
        CurrentScreenName: ko.observable(window.location.pathname),
        PrevLevelDetailId: ko.observable(),
        PrevLevelDetailIdNumber: ko.observable(),
        ClickedLevelDetailIdNumber: ko.observable(),
        InputChange: InputChange,
        InputChangeEvent: ko.observable(false),
        CopyDataButtonClicked: ko.observable(false),
        SaveButtonClick: ko.observable(false),
        ClickedLevelDetailIdDup: ko.observable(),
        ScreenName: ko.observable(),
        AssessmentTypeId: ko.observable(),
        AssessmentType: ko.observable(),
        BuLevelDetailId: ko.observable(),
        ClickedLevDetailId: ko.observable(),
        saveControlsData: saveControlsData,
        copyControlsData: copyControlsData,
        SelectedSurveyComponentIdCw: ko.observable(),
        SurveyCategoryListCw: ko.observableArray([]),
        SurveyCategoryTabClickCw: SurveyCategoryTabClickCw,
        ClickedAreaId: ko.observable(0),
        RiskAreaTypeListW: ko.observableArray([]),
        AreaTypeW: ko.observable('A'),
        RiskAreaWTabClick: RiskAreaWTabClick,
        invokepage: invokepage,
        ComposeBindingFlag: ko.observable(false),
    };

    return ACWViewModel;

    function activate() {
        try {
            var Id = ACWViewModel.appsecurity.getParameterByName('atype');
            ACWViewModel.AssessmentTypeId(Id);
            ACWViewModel.appsecurity.GetAssessmentNames().then(function () {

                ACWViewModel.AssessmentType(ACWViewModel.appsecurity.GetAssessmentName(ACWViewModel.AssessmentTypeId()))
                ACWViewModel.ScreenName(ACWViewModel.AssessmentType() + ' Controls Weightings');
            })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {
            
            ACWViewModel.PrevLevelDetailId('0');
            ACWViewModel.BuLevelDetailId('0');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    };

    function invokepage() {
        try {
            if(ACWViewModel.ComposeBindingFlag()){
                $("#SaveCopydiv").hide();
                $("#NoComponentDataDivCw").hide();
                $("#divControlsWeig").show();
            }
                GetSurveyCategoryTabs();
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: invokepage() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            if (ACWViewModel.appsecurity.isConfigurationFreeze() == 1) {
                ACWViewModel.appsecurity.WriteAccess(false);
            }
            var parent = $(location).attr('href').split('/').pop();
            if (parent.split('?')[0] == 'AMLControlsWeightings') {
                invokepage();
                $("#SaveCopydiv").show();
                $("#divControlsWeig").hide();
                ACWViewModel.ComposeBindingFlag(false);
            } else {
                
                $("#SaveCopydiv").hide();
                $("#NoComponentDataDivCw").hide();
                ACWViewModel.ComposeBindingFlag(true);
                $("#divControlsWeightings_BU").css({ 'margin-top': 'unset !important' });
            }

            $('#RiskAreaTabDivMain').hide();
            
            $(document).on('keydown', 'input', function (e) {
                
                var url = window.location.pathname
                var filename = url.substring(url.lastIndexOf('/') + 1);
                var id = $(this).attr('id');
                var result = '', controlID = '', rows = 0;
                if ((id.substring(0, 25)) == "txt_weightingAMLControls_") {
                    result = id.substring(("txt_weightingAMLControls_").length, id.length);
                    controlID = 'txt_weightingAMLControls_';
                    rows = ACWViewModel.ControlAreaListW().length;
                    columns = ACWViewModel.BusinessUnitsListW().length;
                }
                
                if (e.which == 9 && filename == "AMLControlsWeightings" && rows > 1) {
                    var columnandrownuo = result.indexOf("_");

                    if (controlID == "txt_weightingAMLControls_") {
                        var columnno  = Number(result.substring(0, columnandrownuo));
                        var rowno = Number(result.substring(columnandrownuo + 1, result.length));
                    }
                    
                    var lineno = 0;
                    for (var l = 0; l < ACWViewModel.ControlAreaListW().length - 1; l++) {
                        if (ACWViewModel.ControlAreaListW()[l].ControlAreaId() == rowno) {
                            rowno = ACWViewModel.ControlAreaListW()[l + 1].ControlAreaId();
                            break;
                        }

                        if (l + 2 == rows) {
                            lineno = rows;  //15 was added
                        }
                    }

                    if (lineno == rows) {
                        for (var k = 0; k < ACWViewModel.BusinessUnitsListW().length - 1; k++) {
                            if (ACWViewModel.BusinessUnitsListW()[k].BusinessUnit_ID() == columnno) {
                                columnno = ACWViewModel.BusinessUnitsListW()[k + 1].BusinessUnit_ID();
                                rowno = ACWViewModel.ControlAreaListW()[0].ControlAreaId();
                                break;
                            }
                        }
                    }
                    for (var i = columnno; i < columns; i++) {
                        if (controlID == "txt_weightingAMLControls_") {
                            var tobefocusedid = controlID + columnno + "_" + rowno;
                        }
                       
                        if ($("#" + tobefocusedid).prop('disabled')) {
                            columnno = columnno + 1;
                        }
                        else {
                            break;
                        }
                    }
                    if (columns == columnno | columnandrownuo == -1 | isNaN(rowno)) {
                        //do nothing to make tab work as per its functionality
                    }
                    else if (controlID == "txt_weightingAMLControls_") {
                        e.preventDefault();
                        var tobefocusedid = controlID + columnno + "_" + rowno;
                        if ($("#" + tobefocusedid).prop('disabled')) {

                        }
                        else {
                            $("#" + tobefocusedid).focus();
                            $("#" + tobefocusedid).select();
                        }
                    }
                }
            });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function GetSurveyCategoryTabs() {
        try {
            $('#loadingMainControlsDiv').show();
            $.ajax({
                url: "/api/Configuration/GetControlsSurveyCategoryTabs",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { "AssessmentId": ACWViewModel.AssessmentTypeId(), "ScreenType": "RA" }
            })
                .success(function (jsonResult, success) {
                    try {
                        if (jsonResult != null) {
                            var mappedTabList = $.map(jsonResult, function (result) {
                                return new SurveyCategoryModel(result);
                            });
                            ACWViewModel.SurveyCategoryListCw(mappedTabList);
                            $('#SurveyCategoryTabCw').tabs();
                            $('#SurveyCategoryTabCw').tabs('refresh');
                            $('#SurveyCategoryTabCw').tabs({ active: 0 });
                            $($('#SurveyCategoryTabCw li').get(0)).trigger('click');
                            scrollableTabs();
                            $('#loadingMainControlsDiv').hide();
                        }
                        else {
                            $('#loadingMainControlsDiv').hide();
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() Success method in AMLThresholds.js';
                        logger.logMessage(msg);
                    }

                })
                .fail(function (error, status) {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in AMLThresholds.js';
                        logger.logMessage(msg);
                    }

                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function SurveyCategoryTabClickCw(data, event, flag) {
        try {

            $('#loadingMainDataW').show();
            ACWViewModel.SelectedSurveyComponentIdCw(data.SurveyCategoryId());

            if (flag == undefined)
                flag = 0;
            // $('#divAMLControlsWeightings').removeClass('alert-warning-error');
            $('#lblErrorAMLControls').hide();
            $('#loadingMainControlsDiv').show();
            $('#RiskAreaTabDivMain').hide();
            var PrevLevelDetailId = ACWViewModel.PrevLevelDetailId();

            var PrevLevelDetailIdNumber = "";

            if (PrevLevelDetailId != undefined && PrevLevelDetailId != '0')
                PrevLevelDetailIdNumber = ACWViewModel.PrevLevelDetailId();

            if (ACWViewModel.appsecurity.WriteAccess() == false || ACWViewModel.appsecurity.WriteAccess() == "false") {
                flag = 0;
            }
            if (flag == 0) {
                flag = 1;
                GetRiskLevelDetails();
            }
            else if ((ACWViewModel.InputChangeEvent() || ACWViewModel.CopyDataButtonClicked()) && ACWViewModel.SaveButtonClick() == false) {
                ACWViewModel.InputChangeEvent(false);
                ACWViewModel.CopyDataButtonClicked(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                .then(function (option) {
                    
                    var properText = data.Bulevel();
                    ACWViewModel.ClickedLevelDetailIdNumber(properText);
                    if (option == "Save") {

                        saveWeightingsAMLControls(ACWViewModel.PrevLevelDetailId());
                        if (ACWViewModel.ErrorStatus() == 1) {
                            ACWViewModel.ErrorStatus(0);
                            $('#' + ACWViewModel.PrevLevelDetailId()).addClass('ui-tabs-active ui-state-active');
                            $('#' + data.Bulevel()).removeClass('ui-tabs-active ui-state-active');
                            ACWViewModel.SaveButtonClick(false);
                        }
                        else {
                            ACWViewModel.SaveButtonClick(false);
                            $('#' + ACWViewModel.PrevLevelDetailId()).removeClass('ui-tabs-active ui-state-active');
                            $('#' + data.Bulevel()).addClass('ui-tabs-active ui-state-active');
                            SurveyCategoryTabClickCw(data,event, 0);
                        }
                    }
                    else {
                        $("#lblErrorAMLControls").hide();
                        flag = 1;
                        $('#' + ACWViewModel.PrevLevelDetailId()).removeClass('ui-tabs-active ui-state-active');
                        $('#' + data.Bulevel()).addClass('ui-tabs-active ui-state-active');
                        ACWViewModel.ClickedLevelDetailName(data.BlName());
                        SurveyCategoryTabClickCw(data, event, 0);
                    }
                })

            }
            else {
                ACWViewModel.InputChangeEvent(false);
                ACWViewModel.CopyDataButtonClicked(false);
                ACWViewModel.SaveButtonClick(false);
                $('#' + ACWViewModel.PrevLevelDetailId()).removeClass('ui-tabs-active ui-state-active');
                $('#' + data.Bulevel()).addClass('ui-tabs-active ui-state-active');
                SurveyCategoryTabClickCw(data, event, 0);
            }
           
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClick() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    
    function RiskAreaWTabClick(data, event, flag) {
        try {
             // area click
            $('#RiskAreaTabDivMain').hide();
            $('#loadingMainControlsDiv').show();
            ACWViewModel.ClickedAreaId(data.ControlAreaId()); 

            if (flag == undefined)
                flag = 0;
            // $('#divAMLControlsWeightings').removeClass('alert-warning-error');
            $('#lblErrorAMLControls').hide();
            $('#loadingMainControlsDiv').show();
            $('#RiskAreaTabDivMain').hide();
            var PrevLevelDetailId = ACWViewModel.PrevLevelDetailId();

            var PrevLevelDetailIdNumber = "";

            if (PrevLevelDetailId != undefined && PrevLevelDetailId != '0')
                PrevLevelDetailIdNumber = ACWViewModel.PrevLevelDetailId();

            if (ACWViewModel.appsecurity.WriteAccess() == false || ACWViewModel.appsecurity.WriteAccess() == "false") {
                flag = 0;
            }
            if (flag == 0) {
                flag = 1;
                GetCULevelWeightings(ACWViewModel.ClickedAreaId(), "LOWEST");
            }
            else if ((ACWViewModel.InputChangeEvent() || ACWViewModel.CopyDataButtonClicked()) && ACWViewModel.SaveButtonClick() == false) {
                ACWViewModel.InputChangeEvent(false);
                ACWViewModel.CopyDataButtonClicked(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                .then(function (option) {
                   
                    var properText = data.Bulevel();
                    ACWViewModel.ClickedLevelDetailIdNumber(properText);
                    if (option == "Save") {
                        saveWeightingsAMLControls(ACWViewModel.PrevLevelDetailId());
                        if (ACWViewModel.ErrorStatus() == 1) {
                            ACWViewModel.ErrorStatus(0);
                            ACWViewModel.SaveButtonClick(false);
                            $('#' + ACWViewModel.PrevLevelDetailId()).addClass('ui-tabs-active ui-state-active');
                            $('#' + data.Bulevel()).removeClass('ui-tabs-active ui-state-active');
                        }
                        else {
                            ACWViewModel.SaveButtonClick(false);
                            $('#' + ACWViewModel.PrevLevelDetailId()).removeClass('ui-tabs-active ui-state-active');
                            $('#' + data.Bulevel()).addClass('ui-tabs-active ui-state-active');
                            RiskAreaWTabClick(data, event, 0);
                        }
                    }
                    else {
                        $("#lblErrorAMLControls").hide();
                        flag = 1;
                        $('#' + ACWViewModel.PrevLevelDetailId()).removeClass('ui-tabs-active ui-state-active');
                        $('#' + data.Bulevel()).addClass('ui-tabs-active ui-state-active');
                        ACWViewModel.ClickedLevelDetailName(data.BlName());
                        RiskAreaWTabClick(data, event, 0);
                    }
                })

            }
            else {
                ACWViewModel.InputChangeEvent(false);
                ACWViewModel.CopyDataButtonClicked(false);
                ACWViewModel.SaveButtonClick(false);
                $('#' + PrevLevelDetailIdNumber).removeClass('ui-tabs-active ui-state-active');
                $('#' + data.Bulevel()).addClass('ui-tabs-active ui-state-active');
                RiskAreaWTabClick(data, event, 0);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaWTabClick() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function RiskLevelTabClick(data, flag) {
        try {
             // org click
            ACWViewModel.BuLevelDetailId(data.Bulevel());
                ACWViewModel.ClickedAreaId(0);
                if (flag == undefined)
                    flag = 0;
                // $('#divAMLControlsWeightings').removeClass('alert-warning-error');
                $('#lblErrorAMLControls').hide();
                $('#loadingMainControlsDiv').show();
                $('#RiskAreaTabDivMain').hide();
                var PrevLevelDetailId = ACWViewModel.PrevLevelDetailId();

                var PrevLevelDetailIdNumber = "";

                if (PrevLevelDetailId != undefined && PrevLevelDetailId != '0')
                    PrevLevelDetailIdNumber = ACWViewModel.PrevLevelDetailId();

                if (ACWViewModel.appsecurity.WriteAccess() == false || ACWViewModel.appsecurity.WriteAccess() == "false") {
                    flag = 0;
                }
                if (flag == 0) {
                    flag = 1;
                    ACWViewModel.ClickedLevelDetailName(data.BlName());
                   
                        var ClickedType = "";
                        if (ACWViewModel.BuLevelDetailId() === "-999")
                            GetAllRiskAreasForCategories();
                        else
                            GetCULevelWeightings(ACWViewModel.BuLevelDetailId(), ClickedType);
                }
                else if ((ACWViewModel.InputChangeEvent() || ACWViewModel.CopyDataButtonClicked()) && ACWViewModel.SaveButtonClick() == false) {
                    ACWViewModel.InputChangeEvent(false);
                    ACWViewModel.CopyDataButtonClicked(false);
                    app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                    .then(function (option) {
                       
                        var properText = data.Bulevel();
                        ACWViewModel.ClickedLevelDetailIdNumber(properText);
                        if (option == "Save") {
                            saveWeightingsAMLControls(ACWViewModel.PrevLevelDetailId());
                            if (ACWViewModel.ErrorStatus() == 1) {
                                ACWViewModel.ErrorStatus(0);
                                ACWViewModel.SaveButtonClick(false);
                                $('#' + ACWViewModel.PrevLevelDetailId()).addClass('ui-tabs-active ui-state-active');
                                $('#' + data.Bulevel()).removeClass('ui-tabs-active ui-state-active');
                            }
                            else {
                                ACWViewModel.SaveButtonClick(false);
                                $('#' + ACWViewModel.PrevLevelDetailId()).removeClass('ui-tabs-active ui-state-active');
                                $('#' + data.Bulevel()).addClass('ui-tabs-active ui-state-active');
                                RiskLevelTabClick(data, 0);
                            }
                        }
                        else {
                            $("#lblErrorAMLControls").hide();
                            flag = 1;
                            $('#' + PrevLevelDetailIdNumber).removeClass('ui-tabs-active ui-state-active');
                            $('#' + data.Bulevel()).addClass('ui-tabs-active ui-state-active');

                            ACWViewModel.ClickedLevelDetailName(data.BlName());
                            
                                var ClickedType = "";
                                GetRiskLevelSubtabs(data.Bulevel());
                                if (ACWViewModel.BuLevelDetailId() === "-999")
                                    GetAllRiskAreasForCategories();
                                else
                                    GetCULevelWeightings(ACWViewModel.BuLevelDetailId(), ClickedType);
                        }
                    })

                }
                else {
                    ACWViewModel.InputChangeEvent(false);
                    ACWViewModel.CopyDataButtonClicked(false);
                    ACWViewModel.SaveButtonClick(false);
                    $('#' + ACWViewModel.PrevLevelDetailId()).removeClass('ui-tabs-active ui-state-active');
                    $('#' + data.Bulevel()).addClass('ui-tabs-active ui-state-active');
                    RiskLevelTabClick(data, 0);
                }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskLevelTabClick() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function InputChange(data, event) {
        try {
            ACWViewModel.InputChangeEvent = ko.observable(true).extend({
                notify: 'always'
            });
            GetTotalWeightings();
            GetTotalWeightingsOverall();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InputChange() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function GetAllRiskAreasForCategories() {
        try {
            $.ajax({
                url: "/api/AMLControlRiskAssessment/GetAllControlArea",
                data: {
                    "ParentUID": "NULL", "SurveyCategoryID": ACWViewModel.SelectedSurveyComponentIdCw(),
                    "AssessmentTypes": ACWViewModel.AssessmentTypeId(),
                    "ScreenType": 'RA'
                },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
           .success(ajaxSuccess)
           .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreas() method in AMLThreshold.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null && jsonResult[0].ControlAreaName != null) {
                    var mappedRiskAreaList = $.map(jsonResult, function (result) {
                        return new RiskAreaModel(result);
                    });

                    ACWViewModel.RiskAreaTypeListW(mappedRiskAreaList);
                    //ACWViewModel.countEntry(0);
                    $('#RASubTabW').tabs();
                    $('#RASubTabW').tabs('refresh');
                    $('#RASubTabW').tabs({ active: 0 });
                    $($('#RiskAreaUlW li').get(0)).trigger('click');
                }
                else if (jsonResult[0].ControlAreaName == null)
                    app.showMessage("Risk Areas are not yet configured for this year of assessment. Please configure the Risk Areas.", "Error in Fetching Risk Areas", ["OK"])
                    .then(function (option) {
                        if (option == "OK")
                            router.navigate("configuration/RisksAreasfactors", true);
                    })
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ACWViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in AMLThreshold.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in AMLThreshold.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in AMLThreshold.js';
                logger.logMessage(msg);
            }
        };
    }


    function GetRiskLevelDetails() {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/getAllBusinessUnitLevels",
                data: { "type": ACWViewModel.AssessmentTypeId(), "Page_Type": "W", },
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetRiskLevelDetails() method in AMLControlsWeightings.js';
            logger.logMessage(msg);

        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult.length > 0) {
                    var MappedBUModelList = $.map(jsonResult, function (result) {
                        return new BusinessLevelModel(result);
                    });

                    ACWViewModel.BusinessLevelList(MappedBUModelList);
                    //GetDerivedBusinessLevel();
                    //getAllBusinessUnits();
                    //GetAllControlAreas();
                    $('#RaTab').tabs();
                    $('#RaTab').tabs('refresh');
                    $('#RaTab').tabs({ active: 0 });
                    $($('#RaTab li').get(0)).trigger('click');
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ACWViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelDetails() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRiskLevelDetails() method in AMLControlsWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRiskLevelDetails() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetDerivedBusinessLevel() {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/GetDerivedBusinessLevel",
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetDerivedBusinessLevel() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var mappedbumodel = $.map(jsonResult, function (result) {
                        return new BusinessUnitDerivedlevelModel(result);
                    });
                    var max = "";
                    for (var i = 0; i < ACWViewModel.BusinessLevelList().length; i++) {
                        if (i == 0) {
                            max = ACWViewModel.BusinessLevelList()[i].Bulevel();
                        }
                        if (ACWViewModel.BusinessLevelList()[i].BlName().toUpperCase() == (mappedbumodel[0].DerivedLevel()).toUpperCase()) {

                            max = ACWViewModel.BusinessLevelList()[i].Bulevel();
                        }
                    }
                    ACWViewModel.Overalllowestlevel(max);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetDerivedBusinessLevel() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in operation.", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetDerivedBusinessLevel() method in AMLControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetDerivedBusinessLevel() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        };
    }

    function GetAllControlAreas() {
        try {
            $.ajax({
                url: "/api/ControlArea/GetAllControlArea?Type=" + ACWViewModel.AssessmentTypeId(),
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllControlAreas() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult !== 'undefined' && jsonResult != null && jsonResult != "") {
                    $('#NoAMLControlareasserror').hide();
                    $('#RiskAreaTabDivMain').show();
                    var mappedControlAreas = $.map(jsonResult, function (result) {
                        return new ControlAreas(result);
                    });
                    ACWViewModel.ControlAreaListW(mappedControlAreas);
                    $('#NoAMLControlareasserror').hide();
                    $('#RiskAreaTabDivMain').show();

                }
                else {
                    app.showMessage("Control Areas are not configured.", "Error", ["OK"]);
                    $('#NoAMLControlareasserror').show();
                    $('#RiskAreaTabDivMain').hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllControlAreas() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllControlAreas() method in AMLControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllControlAreas() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        };
    }
    function GetTotalWeightings() {
        try {
            for (var k = 0; k < ACWViewModel.BusinessUnitsListW().length; k++) {
                var sum = parseFloat(0);
                for (var i = 0; i < ACWViewModel.ControlAreaListW().length; i++) {
                    var x = "#txt_weightingAMLControls_" + ACWViewModel.BusinessUnitsListW()[k].BusinessUnit_ID() + "_" + ACWViewModel.ControlAreaListW()[i].ControlAreaId();
                    sum = parseFloat(sum) + parseFloat($(x).val());
                }
                var colcount = ACWViewModel.BusinessUnitsListW()[k].BusinessUnit_ID();
                if (isNaN(sum)) {
                    $("#txt_weightingAMLControls_" + colcount).val(0);
                }
                else {
                    $("#txt_weightingAMLControls_" + colcount).val(parseFloat(sum).toFixed(2));
                }
                if (sum == 100) {
                    $("#txt_weightingAMLControls_" + colcount).css('color', '#000000')
                    $("#txt_weightingAMLControls_" + colcount).css("background-color", "#cccccc")
                } else {
                    $("#txt_weightingAMLControls_" + colcount).css('color', 'red')
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetTotalWeightings() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }
    function GetTotalWeightingsOverall() {
        try {
            for (var k = 0; k < ACWViewModel.BusinessLevelDetailsList().length; k++) {
                var sum = parseFloat(0);
                for (var i = 0; i < ACWViewModel.ControlAreaListW().length; i++) {

                    var x = "#txt_BULweightingCon_" + ACWViewModel.BusinessLevelDetailsList()[k].DetailId() + "_" + ACWViewModel.ControlAreaListW()[i].ControlAreaId();
                    sum = parseFloat(sum) + parseFloat($(x).val());
                }
                var colcount = ACWViewModel.BusinessLevelDetailsList()[k].DetailId();
                if (isNaN(sum)) {
                    $("#txt_BULweightingCon_" + colcount).val(0);
                }
                else {
                    $("#txt_BULweightingCon_" + colcount).val(parseFloat(sum).toFixed(2));
                }
                if (sum == 100) {
                    $("#txt_BULweightingCon_" + colcount).css('color', '#000000')
                    $("#txt_BULweightingCon_" + colcount).css("background-color", "#cccccc")
                } else {
                    $("#txt_BULweightingCon_" + colcount).css('color', 'red')
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetTotalWeightingsOverall() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function GetCULevelWeightings(abc, clickedType) {
        try {
            
            //if (ACWViewModel.PrevLevelDetailId() == undefined || ACWViewModel.PrevLevelDetailId() == '0')
                ACWViewModel.PrevLevelDetailId(abc);

            $.ajax({
                url: "/api/WeightingsThresholds/GetCULevelWeightings",
                data: {
                    "RiskAreaType": ACWViewModel.AssessmentTypeId(), "DeUid": ACWViewModel.BuLevelDetailId(),
                    "ComponentId": ACWViewModel.SelectedSurveyComponentIdCw(), "AreaId": ACWViewModel.ClickedAreaId()
                },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetBUlevelWeightings() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    
                    ACWViewModel.ControlAreaListW([]);
                    var mappedControlAreas = $.map(jsonResult.AreasList, function (result) {
                        return new ControlAreas(result);
                    });
                    ACWViewModel.ControlAreaListW(mappedControlAreas);

                    ACWViewModel.BusinessUnitsListW([]);
                    var MappedBUModelList = $.map(jsonResult.BUList, function (result) {
                        return new BusinessUnitModel(result);
                    });
                    ACWViewModel.BusinessUnitsListW(MappedBUModelList);

                    $('#RiskAreaTabDivMain').show();
                    $('#divControlsWeightings_BU').show();

                    if ($.fn.DataTable.isDataTable('#WeightingsTable1')) {
                        var tableObj = $('#WeightingsTable1').DataTable();
                        tableObj.fixedHeader.disable();
                        tableObj.destroy();
                        $('#WeightingsTable1 tbody tr').remove();
                        $("#trOneW > th").remove();
                        $("#trTwoW > th").remove();
                        var htmlHeaders = "";

                        htmlHeaders += '<th class="" style=""><span class="glyphicon glyphicon-arrow-down"></span>Control Areas  / <span class="glyphicon glyphicon-arrow-right"></span>Business Units</th>'
                        for (var i = 0; i < ACWViewModel.BusinessUnitsListW().length; i++) {

                            htmlHeaders += '<th style="text-align:left;vertical-align:middle;" title="' + ACWViewModel.BusinessUnitsListW()[i].BusinessUnit_NameTitle() + '" class="noSort" data-bind="text: ' + ACWViewModel.BusinessUnitsListW()[i].BusinessUnit_Name() + ', attr:{id: ' + ACWViewModel.BusinessUnitsListW()[i].BusinessUnit_ID() + ', \'title\': ' + ACWViewModel.BusinessUnitsListW()[i].BusinessUnit_NameTitle() + '}, css:{\'long header-ellipsis\': true}">' + ACWViewModel.BusinessUnitsListW()[i].BusinessUnit_Name() + '</th>'
                        }
                        $("#trOneW").append(htmlHeaders);

                        var htmlHeaders1 = "";
                        htmlHeaders1 += '<th class="noSort" style="border-bottom: unset !important;font-weight:700;text-align: left;vertical-align:middle;background-color:#00a3e0;">Total</th>'
                        for (var i = 0; i < ACWViewModel.BusinessUnitsListW().length; i++) {
                            htmlHeaders1 += '<th class="noSort" style="text-align:center;vertical-align:middle;background-color:white;border: 1px solid #ccc !important;">'
                            htmlHeaders1 += '<div class="input-group" style="text-align:center;vertical-align:middle;">'
                            htmlHeaders1 += '<input type="text" disabled style="font-weight: 600;position:unset !important;background-color:#cccccc;" class="form-control inputWBU" id="txt_weightingAMLControls_' + ACWViewModel.BusinessUnitsListW()[i].BusinessUnit_ID() + '" }">'
                            htmlHeaders1 += '<span class="input-group-addon">%</span>'
                            htmlHeaders1 += ' </div>'
                            htmlHeaders1 += '</th>'
                        }
                        $("#trTwoW").append(htmlHeaders1);

                    }
                    var mappedWeightings = $.map(jsonResult.WeightingsDataList, function (result) {
                        return new WeightingDataModel(result);
                    });
                    ACWViewModel.WeightingsDataList(mappedWeightings);

                    $('#loadingMainControlsDiv').hide();
                    $('#RiskAreaTabDivMain').show();
                    $('#divControlsWeightings_BU').show();
                    $('#divControlsWeightings_SBU').hide();
                    
                    var scrollHeight = "33rem";

                    if (ACWViewModel.ComposeBindingFlag()) {
                        scrollHeight = "25rem";
                    }

                    var oTable = $('#WeightingsTable1').DataTable(
                        {
                            'aoColumnDefs': [{
                                'bSortable': false,
                                "targets": "_all"
                                //'aTargets': ['noSort']
                            }],
                            "aaSorting": [],
                            scrollY: scrollHeight,
                            scrollX: true,
                            scrollCollapse: true,
                            fixedColumns: true,
                            paging: false,
                            "bInfo": false,
                            "bAutoWidth": false,
                            fixedColumns: {
                                leftColumns: 1
                            },
                            fixedheader: {
                                header: true
                            },
                        });

                    $('#WeightingsTable1').closest(".dataTables_wrapper").find("*").css("box-sizing", "content-box").css("-moz-box-sizing", "content-box");

                    //var PrevLevelDetailIdNumber = ACWViewModel.PrevLevelDetailId();

                    //$('#' + PrevLevelDetailIdNumber).removeClass('ui-tabs-active ui-state-active');
                    //$('#' + ACWViewModel.BuLevelDetailId()).addClass('ui-tabs-active ui-state-active');
                    GetTotalWeightings();

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetBUlevelWeightings() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBUlevelWeightings() method in AMLControlsWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBUlevelWeightings() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
    }

    function getAllBusinessUnits() {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/GetAllBusinessUnits",
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in getAllBusinessUnits() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResultObj, status) {
            try {
                if (jsonResultObj == undefined || jsonResultObj.length == 0) {
                    app.showMessage("Business unit configurations are not in place.", "Error", ["OK"]);
                    $("#NobusinessUnitserrorAML").show();
                    $("#RaTab").hide();
                } else {
                    var mappedBusinessUnits = $.map(jsonResultObj, function (result) {
                        return new BusinessUnits(result);
                    });
                    ACWViewModel.BusinessUnitsListW(mappedBusinessUnits);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in getAllBusinessUnits() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllBusinessUnits() method in AMLControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        };

    };
    function GetRiskLevelSubtabs(LevelID) {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/getBusinessUnitLevelDetails",
                data: { "levelid": LevelID },
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetRiskLevelSubtabs() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult.length != 0) {
                        var mappedBULevelsList = $.map(jsonResult, function (result) {
                            return new BusinessLevelDetail(result);
                        });
                        ACWViewModel.BusinessLevelDetailsList(mappedBULevelsList);
                    }
                    else {
                        ACWViewModel.BusinessLevelDetailsList([]);
                    }
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ACWViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelSubtabs() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRiskLevelSubtabs() method in AMLControlsWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRiskLevelSubtabs() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
    }

    function ImplementOverallWeightingsSecurity() {
        try {
            if (ACWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblConWeightingsBU-' + ACWViewModel.ClickedLevDetailId() + ' tbody').find('input').length; i++) {
                    $($('#tblConWeightingsBU-' + ACWViewModel.ClickedLevDetailId() + ' tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ImplementOverallWeightingsSecurity() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }
    function ImplementSecurity() {
        try {
            if (ACWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblAMLControlsWeightings tbody').find('input').length; i++) {
                    $($('#tblAMLControlsWeightings tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ImplementSecurity() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }
    function buildsaveConBULOverallWeightingsList() {
        try {
            ACWViewModel.BULWeightingsListSave([]);
            var rows = ACWViewModel.ControlAreaListW().length;
            var cols = ACWViewModel.BusinessUnitsListW().length;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_weightingAMLControls_' + ACWViewModel.BusinessUnitsListW()[j].BusinessUnit_ID() + '_' + ACWViewModel.ControlAreaListW()[i].ControlAreaId()
                    var newObj = new WeightingModel({
                        'Id': ACWViewModel.ControlAreaListW()[i].ControlAreaId(), 'BuId': ACWViewModel.BusinessUnitsListW()[j].BusinessUnit_ID(),
                        'WeightingValue': $(txtid).val()
                    });
                    ACWViewModel.BULWeightingsListSave().push(newObj);
                }
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveBULWeightingsList() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }

    }
    function buildsaveConBULWeightingsList() {
        try {
            ACWViewModel.BULWeightingsListSave([]);
            var rows = ACWViewModel.ControlAreaListW().length;
            var cols = ACWViewModel.BusinessLevelDetailsList().length;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_BULweightingCon_' + ACWViewModel.BusinessLevelDetailsList()[j].DetailId() + '_' + ACWViewModel.ControlAreaListW()[i].ControlAreaId();
                    var newObj = new WeightingModel({
                        'Id': ACWViewModel.ControlAreaListW()[i].ControlAreaId(), 'BuId': ACWViewModel.BusinessLevelDetailsList()[j].DetailId(),
                        'WeightingValue': $(txtid).val()
                    });
                    ACWViewModel.BULWeightingsListSave().push(newObj);
                }
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveBULWeightingsList() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function saveControlsData() {
        try {
            saveWeightingsAMLControls();
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveControlsData() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function saveAMLLevelControlsWeightings(previousTabFlag) {
        try {
            $('#loadingMainControlsDiv').show();
            $('#RiskAreaTabDivMain').hide();
            ACWViewModel.SaveButtonClick(true);
            $("#lblErrorAMLControls-").hide();
            var colsBUL = ACWViewModel.BusinessLevelDetailsList().length - 1;
            var rows = ACWViewModel.ControlAreaListW().length;
            var tableId = '.WeightingsTable2';

            var valid = 1;
            var check = 0;

            for (var i = 0; i <= colsBUL; i++) {
                var sum = 0;

                for (var j = 0; j < rows; j++) {
                    var txtValue = $("#txt_BULweightingCon_" + ACWViewModel.BusinessLevelDetailsList()[i].DetailId() + "_" + ACWViewModel.ControlAreaListW()[j].ControlAreaId()).val();

                    if (txtValue == "") {
                        $("#txt_BULweightingCon_" + ACWViewModel.BusinessLevelDetailsList()[i].DetailId() + "_" + ACWViewModel.ControlAreaListW()[j].ControlAreaId()).val(0);
                    }
                    if (!$.isNumeric(txtValue)) {
                        valid = 0;
                        $("#lblErrorAMLControls-").show();
                        $("#lblErrorAMLControls-").text('Non-numeric values are not allowed.');
                        check = 1;
                    }
                    else if (txtValue < 0 || txtValue > 100) {
                        valid = 0;
                        $("#lblErrorAMLControls-").show();
                        $("#lblErrorAMLControls-").text('Value should be in range of (0-100).');
                        check = 1;
                    }
                    else {
                        sum += parseFloat(txtValue);
                    }
                }
                if (sum != 100 && sum != 0) {
                    if (check == 0) {
                        valid = 0;
                        $('#loadingMainControlsDiv').hide();
                        $('#RiskAreaTabDivMain').show();
                        $("#lblErrorAMLControls-").show();
                        $("#lblErrorAMLControls-").text('The total for weightings across control areas should be 100% for organization sublevel  ' + ACWViewModel.BusinessLevelDetailsList()[i].DetailName() + '.');
                        break;
                    }
                }
            }
            if (valid == 0) {
                ACWViewModel.ErrorStatus(1);
                $('#loadingMainControlsDiv').hide();
                $('#RiskAreaTabDivMain').show();
            }
            if (valid == 1) {
                try {
                    
                    var levelId = ACWViewModel.ClickedLevDetailId();
                    if (previousTabFlag === undefined)
                        levelId = ACWViewModel.ClickedLevDetailId();
                    else
                        levelId = previousTabFlag;

                    buildsaveConBULWeightingsList();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/WeightingsThresholds/SaveControlWeightingsBUL?RiskAreaType=" + ACWViewModel.AssessmentTypeId() + "&BUL_Entity_ID=" + levelId,//to save the bu level wieghtings.
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify($.map(ACWViewModel.BULWeightingsListSave(), function (item) {
                            return { Id: item.ControlAreaId(), BuId: item.BuId(), WeightingValue: item.WeightingValue() };
                        }))
                    })
                    .success(ajaxSuccessOverallBU)
                    .fail(ajaxFailOverallBU);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveBULWeightings() method in AMLControlsWeightings.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccessOverallBU(jsonResult, status) {
                    try {
                        if (jsonResult != null && jsonResult != 0) {
                            ACWViewModel.WeightingsList([]);
                            //$(tableId).remove();
                            if (ACWViewModel.BuLevelDetailId() == ACWViewModel.Overalllowestlevel()) {
                                GetCULevelWeightings(ACWViewModel.ClickedLevDetailId(), "LOWEST");
                            }
                            else {
                                var ClickedType = "";
                                if (ACWViewModel.BuLevelDetailId() === "-999")
                                    GetAllRiskAreasForCategories();
                                else
                                    GetCULevelWeightings(ACWViewModel.ClickedLevDetailId(), ClickedType);
                            }
                            $("#lblErrorAMLControls-").hide();
                            logger.logSuccess('Overall Controls Weightings for Business Unit Levels saved successfully.', 'Success', system.getModuleId(ACWViewModel), true);
                        }
                        else {
                            logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(ACWViewModel), true);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveBULWeightings() method in AMLControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFailOverallBU(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveBULWeightings() method in AMLControlsWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveBULWeightings() method in AMLControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                }
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveBULWeightings() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }

    }

    function saveWeightingsAMLControls(previousTabFlag) {
        try {
            
            $('#loadingMainControlsDiv').show();
           // $('#RiskAreaTabDivMain').hide();
            ACWViewModel.SaveButtonClick(true);
            $("#lblErrorAMLControls").hide();
            var cols = ACWViewModel.BusinessUnitsListW().length;
            var rows = ACWViewModel.ControlAreaListW().length;
            var valid = 1;
            var check = 0;

            for (var i = 0; i < cols; i++) {
                var sum = 0;
                for (var j = 0; j < rows; j++) {
                    var txtValue = $("#txt_weightingAMLControls_" + ACWViewModel.BusinessUnitsListW()[i].BusinessUnit_ID() + "_" + ACWViewModel.ControlAreaListW()[j].ControlAreaId()).val();

                    if (txtValue == "") {
                        $("#txt_weightingAMLControls_" + ACWViewModel.BusinessUnitsListW()[i].BusinessUnit_ID() + "_" + ACWViewModel.ControlAreaListW()[j].ControlAreaId()).val(0);
                        $('#loadingMainControlsDiv').hide();
                        $('#RiskAreaTabDivMain').show();
                        break;
                    }
                    if (!$.isNumeric(txtValue)) {
                        valid = 0;
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('Non-numeric values are not allowed.');
                        check = 1;
                        $('#loadingMainControlsDiv').hide();
                        $('#RiskAreaTabDivMain').show();
                        break;
                    }
                    else if (txtValue < 0 || txtValue > 100) {
                        valid = 0;
                        $("#lblErrorAMLControls").show();
                        $('#RiskAreaTabDivMain').show();
                        $("#lblErrorAMLControls").text('Value should be in range of (0-100).');
                        $('#loadingMainControlsDiv').hide();
                        break;
                    }
                    else {
                        sum += parseFloat(txtValue);
                    }
                }
                if (sum != 100 && sum != 0) {
                    if (check == 0) {
                        valid = 0;
                        $('#loadingMainControlsDiv').hide();
                        $('#RiskAreaTabDivMain').show();
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('The total for weightings across control areas should be 100% for business unit ' + ACWViewModel.BusinessUnitsListW()[i].BusinessUnit_Name() + '.');
                        break;
                    }
                }
            }
            if (valid == 0) {
                ACWViewModel.ErrorStatus(1);
                $('#loadingMainControlsDiv').hide();
                $('#RiskAreaTabDivMain').show();
            }
            if (valid == 1) {
                try {
                    var levelId = ACWViewModel.BuLevelDetailId();
                    if (previousTabFlag === undefined)
                        levelId = ACWViewModel.BuLevelDetailId();
                    else
                        levelId = previousTabFlag;

                    buildsaveConBULOverallWeightingsList();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/WeightingsThresholds/SaveControlWeightingsBUL?RiskAreaType=" + ACWViewModel.AssessmentTypeId() + "&BUL_Entity_ID=" + levelId,//to save the bu level wieghtings.
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify($.map(ACWViewModel.BULWeightingsListSave(), function (item) {
                            return { Id: item.ControlAreaId(), BuId: item.BuId(), WeightingValue: item.WeightingValue() };
                        }))
                    })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveWeightingsAMLControls() method in AMLControlsWeightings.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, status) {
                    try {
                        
                        if (jsonResult != null) {
                            
                            if (previousTabFlag === undefined) {
                                var ClickedType = "";
                                if (ACWViewModel.BuLevelDetailId() === "-999")
                                    GetAllRiskAreasForCategories();
                                else
                                    GetCULevelWeightings(ACWViewModel.ClickedLevDetailId(), ClickedType);
                            }
                            logger.logSuccess('AML Controls Weightings saved successfully.', 'Success', system.getModuleId(ACWViewModel), true);
                        }
                        else {
                            logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(ACWViewModel), true);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveWeightingsAMLControls() method in AMLControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveWeightingsAMLControls() method in AMLControlsWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeightingsAMLControls() method in AMLControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveWeightingsAMLControls() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function copyControlsData() {
        try {
                copyDataAMLControls();
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyControlsData() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function copyDataAMLControls(event) {
        try {
            $('#loadingMainControlsDiv').show();
            ACWViewModel.CopyDataButtonClicked = ko.observable(true).extend({ notify: 'always' });
            var cols = ACWViewModel.BusinessUnitsListW().length;
            $("#lblErrorAMLControls").hide();
            var valid = 0;
            var selectedRowId = 0;
            var selectedColId = 0;
            var wValue = 0;
            var sum = 0;
            var rows;
            rows = ACWViewModel.ControlAreaListW().length;
            var weightingsvaluearray = []

            for (var k = 0; k < ACWViewModel.BusinessUnitsListW().length; k++) {
                if (k == 0) {
                    for (var i = 0; i < ACWViewModel.ControlAreaListW().length; i++) {
                        var txtValue = $("#txt_weightingAMLControls_" + ACWViewModel.BusinessUnitsListW()[k].BusinessUnit_ID() + "_" + ACWViewModel.ControlAreaListW()[i].ControlAreaId()).val();

                        if (txtValue == "") {
                            $("#lblErrorAMLControls").show();
                            $("#lblErrorAMLControls").text('Cell cannot be left blank.');
                            valid = 1;
                            $('#loadingMainControlsDiv').hide();
                            break;
                        }
                        else {
                            var txt = parseFloat(txtValue);
                            if (!$.isNumeric(txt)) {
                                $("#lblErrorAMLControls").show();
                                $("#lblErrorAMLControls").text('Non-numeric entry is not allowed.');
                                valid = 1;
                                $('#loadingMainControlsDiv').hide();
                                break;
                            }
                            else if (txt < 0 || txt > 100) {
                                $("#lblErrorAMLControls").show();
                                $("#lblErrorAMLControls").text('Value should be in range of (0-100).');
                                valid = 1;
                                $('#loadingMainControlsDiv').hide();
                                break;
                            }
                            else {
                                weightingsvaluearray.push(txt);
                                sum += txt;
                            }
                        }
                    }
                }
            }

            if (valid == 1) {
                ACWViewModel.ErrorStatus(1);
            }
            if (valid == 0) {            
                for (var i = 0; i < rows; i++) {
                    selectedRowId = ACWViewModel.ControlAreaListW()[i].ControlAreaId();
                    for (var j = 0; j < cols; j++) {
                        selectedColId = ACWViewModel.BusinessUnitsListW()[j].BusinessUnit_ID();
                        for (var k = 0; k < ACWViewModel.WeightingsDataList().length; k++) {
                            if (selectedRowId == ACWViewModel.WeightingsDataList()[k].RiskAreaId()) {
                                var buList = ACWViewModel.WeightingsDataList()[k].BusinessUnitCountList;
                                for (var m = 0; m < buList.length; m++) {
                                    var weightingNode = buList[m];
                                    if (selectedColId == weightingNode.ResponseList[0].BuId() && selectedRowId == weightingNode.ResponseList[0].RiskAreaId()) {
                                        weightingNode.ResponseList[0].WeightingValue(weightingsvaluearray[i]);
                                    }
                                }
                            }
                        }
                    }
                }
            }
            GetTotalWeightings();
            $('#loadingMainControlsDiv').hide();

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyDataAMLControls() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function copyOverallData() {
        try {
            $('#loadingMainControlsDiv').show();
            $('#divAMLControlsWeightings').hide();
            
            ACWViewModel.CopyDataButtonClicked(true).extend({
                notify: 'always'
            });

            var cols = ACWViewModel.BusinessLevelDetailsList().length;
            $("#lblErrorAMLControls").hide();
            var valid = 0;
            var selectedRowId = 0;
            var selectedColId = 0;
            var wValue = 0;
            var sum = 0;
            var rows;
            var tableid = 'WeightingsTable2';
            rows = ACWViewModel.ControlAreaListW().length;
            var Weightingvalue = [];

            for (var k = 0; k < ACWViewModel.BusinessLevelDetailsList().length; k++) {
                var sum = parseFloat(0);
                for (var i = 0; i < ACWViewModel.ControlAreaListW().length; i++) {

                    var txtValue = $("#txt_BULweightingCon_" + ACWViewModel.BusinessLevelDetailsList()[k].DetailId() + "_" + ACWViewModel.ControlAreaListW()[i].ControlAreaId()).val();
                    if (txtValue == "") {
                        $("#lblErrorAMLControls-").show();
                        $("#lblErrorAMLControls-").text('Cell cannot be left blank.');
                        valid = 1;
                        $('#loadingMainControlsDiv').hide();
                        break;
                    }
                    else {
                        var txt = parseFloat(txtValue);
                        if (!$.isNumeric(txt)) {
                            $("#lblErrorAMLControls-").show();
                            $("#lblErrorAMLControls-").text('Non-numeric entry is not allowed.');
                            valid = 1;
                            $('#loadingMainControlsDiv').hide();
                            break;
                        }
                        else if (txt < 0 || txt > 100) {
                            $("#lblErrorAMLControls-").show();
                            $("#lblErrorAMLControls-").text('Value should be in range of (0-100).');
                            valid = 1;
                             $('#loadingMainControlsDiv').hide();
                            break;
                        }
                        else {
                            Weightingvalue.push(txt);
                            sum += txt;
                        }
                    }
                }
            }
            if (valid == 1) {
                ACWViewModel.ErrorStatus(1);
            }
            if (valid == 0) {
                for (var i = 0; i < rows; i++) {
                    selectedRowId = ACWViewModel.ControlAreaListW()[i].ControlAreaId();
                    for (var j = 0; j < cols; j++) {
                        selectedColId = ACWViewModel.BusinessLevelDetailsList()[j].DetailId();
                        for (var k = 0; k < ACWViewModel.WeightingsDataList().length; k++) {
                            if (selectedRowId == ACWViewModel.WeightingsDataList()[k].RiskAreaId()) {
                                var buList = ACWViewModel.WeightingsDataList()[k].BusinessUnitCountList();
                                for (var m = 0; m < buList.length; m++) {
                                    var weightingNode = buList[m];
                                    if (selectedColId == weightingNode.ResponseList[0].BuId() && selectedRowId == weightingNode.ResponseList[0].RiskAreaId()) {
                                        weightingNode.ResponseList[0].WeightingValue(Weightingvalue[i]);
                                    }
                                }
                            }
                        }
                    }
                }

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyDataAMLControls() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function MapWeightingsDataList(checkWeighting) {
        try {
                    }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: MapWeightingsDataList() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    //-------------------------------------------------------------------Model Definition Starts Here----------------------------------------------------------------------------
    function AreaModel(item) {
        try {
            var self = this;
            self.ControlAreaId = ko.observable(item.ControlAreaId);
            self.ControlAreaName = ko.observable($('<div/>').html(item.ControlAreaName).text());
            self.rowData = item.rowData;
        }
        catch (e) {
            var msg = 'exception' + e + 'source: AreaModel() in AmlControlRiskHeatMap.js';
            logger.logMessage(msg);
        }
    }

    function BusinessUnits(item) {
        try {
            var self = this;
            self.BusinessUnit_ID = ko.observable(item.BuId);

            var BuName = item.BuName;
            if (item.BuName.length > 17) {
                BuName = item.BuName.substring(0, 17) + '...';

            } else {
                var space = item.BuName.length;
                var spaceText = '';
                for (j = 0; j < 20 - space; j++) {
                    spaceText += '&nbsp';
                }
                BuName = item.BuName + spaceText;
            }
            self.BusinessUnit_NameTitle = ko.observable($('<div/>').html(item.BuName).text());
            self.BusinessUnit_Name = ko.observable($('<div/>').html(BuName).text());
            self.BuAssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
            self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnits() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function BusinessUnitModel(item) {
        try {
            var self = this;
            self.BusinessUnit_ID = ko.observable(item.BuLId);
            var BuName = item.BuLevelName;
            if (item.BuLevelName.length > 17) {
                BuName = item.BuLevelName.substring(0, 17) + '...';

            } else {
                var space = item.BuLevelName.length;
                var spaceText = '';
                for (j = 0; j < 20 - space; j++) {
                    spaceText += '&nbsp';
                }
                BuName = item.BuLevelName + spaceText;
            }
            self.BusinessUnit_NameTitle = ko.observable($('<div/>').html(item.BuLevelName).text());
            self.BusinessUnit_Name = ko.observable($('<div/>').html(BuName).text());
            self.SortOrder = ko.observable($('<div/>').html(item.SortOrder).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnits() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function ControlAreas(item) {
        try {
            var self = this;
            self.ControlAreaId = ko.observable(item.RiskAreaId);
            self.ControlAreaName = ko.observable($('<div/>').html(item.AreaName).text());
            self.Rank = ko.observable($('<div/>').html(item.AMLRank).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlAreas() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }
    function BusinessLevelModel(item) {
        try {
            var self = this;
            self.Bulevel = ko.observable($('<div/>').html(item.BuLId).text());
            self.BlName = ko.observable($('<div/>').html(item.BuLevelName).text());
            self.SortOrder = ko.observable($('<div/>').html(item.SortOrder).text());
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }
    function BusinessLevelDetail(item) {
        try {
            var self = this;
            self.DetailId = ko.observable(item.BuLevelDetailId);
            self.DetailName = ko.observable($('<div/>').html(item.BuLevelDetailName).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelDetail() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    };
    function WeightingModel(item) {
        try {
            var self = this;
            self.ControlAreaId = ko.observable(item.Id);
            self.BuId = ko.observable(item.BuId);
            self.WeightingValue = ko.observable(item.WeightingValue);

            if (item.ControlAreaName != undefined)
                self.ControlAreaName = ko.observable(item.ControlAreaName);

            if (item.BuStatus != undefined)
                self.BuStatus = ko.observable(item.BuStatus);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: WeightingModel() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

  
        function WeightingDataModel(item) {
            try {
                var self = this;
                self.RiskAreaId = ko.observable($('<div/>').html(item.RiskAreaId).text());
                self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());

                var MappedObject = $.map(item.BusinessUnitCountList, function (result) {
                    return new BUCountListModel(result);
                });
                self.BusinessUnitCountList = MappedObject;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubFactorDataListModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function BUCountListModel(item) {
            try {
                var self = this;
                var MappedObject = $.map(item.ResponseList, function (result) {
                    return new RiskLevelModel(result);
                });
                self.ResponseList = MappedObject;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubFactorDataListModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
    //This Model captures Risk Areas 
        function RiskAreaModel(item) {
            try {

                var self = this;
                self.ControlAreaName = ko.observable($('<div/>').html(item.ControlAreaName).text());
                self.ControlArealongName = ko.observable($('<div/>').html(item.ControlArealongName).text())
                self.ControlAreaId = ko.observable(item.ControlAreaId);
                self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
                self.RiskAreaNotes = ko.observable($('<div/>').html(item.RiskAreaNotes).text());
                self.hasSubArea = ko.observable(item.hasSubArea);
                self.AreaType = ko.observable($('<div/>').html(item.AreaType).text());

                ACWViewModel.AreaTypeW(item.AreaType);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
        function RiskLevelModel(item) {
            try {
                var self = this;
                self.RiskAreaId = ko.observable($('<div/>').html(item.RiskAreaId).text());
                self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
                self.BuId = ko.observable($('<div/>').html(item.BuId).text());
                self.Bu_Name = ko.observable($('<div/>').html(item.Bu_Name).text());
                self.WeightingValue = ko.observable($('<div/>').html(item.WeightingValue).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RiskLevelModel() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
        

    function BusinessUnitDerivedlevelModel(item) {
        try {
            var self = this;
            self.DerivedLevel = ko.observable($('<div/>').html(item.DerivedLevel).text());
            self.DerivedLevelID = ko.observable($('<div/>').html(item.DerivedLevelID).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnitDerivedlevelModel() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function SurveyCategoryModel(item) {
        try {
            var self = this;
            self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
            self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
            self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
            self.SurveyType = ko.observable(item.SurveyType);
            self.Applicability = ko.observable(item.Applicability);
            self.SurveyGroupId = ko.observable(item.SurveyGroupId);
            self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
            self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
            self.IsEditable = ko.observable(item.IsEditable);
            self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
            self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }
    //-------------------------------------------------------------------Model Definition Ends Here----------------------------------------------------------------------------
});


//-------------------------------------------------------------------------------------------------------------------------------------------------

;
